export { default } from './CamPlayerRewindsScrubber';
